import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

// components
import { Navbar1 } from 'components/navbars';
import { BlogPost3 } from 'components/blog';
import { Footer1, Footer2 } from 'components/footer';
import BackToTop from 'components/BackToTop';

import Hero from './Hero';
import BlogPost1 from './BlogPost1';
import BlogPost2 from './BlogPost2';
import SubscriptionForm from './SubscriptionForm';

// dummy data
import { post1, post2, post3 } from './data';
import { Post1 } from 'components/blog';
// images
import hero from 'assets/images/blog/hero.jpg';
import { getAllBlogs, getSEODataList } from 'helpers/api/BlogService';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { usePageTracking } from 'helpers/usePageTracking';
import Seo from 'components/Seo';

interface BlogPost {
    id: number;
    blogTitle: string;
    shortDescription: string;
    status: number;
    blogTags: string;
    blogImage: string;
    createdOn: string;
    metaKeywords: string
}

const Blog = () => {

    const [allBlogList, setAllBlogList] = useState<Post1[]>([]);

    const [selectedTag, setSelectedTag] = useState<string | null>(null);
    const [seoTitle, setSeoTitle] = useState("");
    const [seoDescription, setSeoDescription] = useState("");
    const [seoKeywords, setSeoKeywords] = useState("");

    const seo = usePageTracking("blogs");

    useEffect(() => {
        const fetchSEO = async () => {
            try {
                const res = await getSEODataList();

                if (res?.success && Array.isArray(res.result)) {
                    // find SEO for blogsDetails
                    const seo = res.result.find(
                        (item: any) => item.pageName === "blogsDetails"
                    );

                    if (seo) {
                        setSeoTitle(seo.pageTitle);
                        setSeoDescription(seo.seoMetaDescription);
                        setSeoKeywords(seo.seoMetaKeywords);
                    }
                }
            } catch (err) {
                console.error("SEO load failed", err);
            }
        };

        fetchSEO();
    }, []);

    useEffect(() => {
        const fetchBlogs = async () => {
            try {
                const response = await getAllBlogs();


                if (response?.success && Array.isArray(response.result)) {
                    const activeBlogs = response.result.filter((blog: any) => blog.status === 1);

                    const transformedData: Post1[] = activeBlogs.map((blog: any) => ({
                        id: blog.id,
                        title: blog.blogTitle,
                        description: blog.shortDescription,
                        image: `${blog.blogImage}`,
                        tag: blog.blogTags,
                        createdOn: blog.createdOn,
                        metaKeywords: blog.metaKeywords
                    }));

                    setAllBlogList(transformedData);
                } else {
                    console.error('Invalid response format:', response);
                }
            } catch (error) {
                console.error('Failed to fetch blogs:', error);
            }
        };

        fetchBlogs();
    }, []);

    const uniqueTags = Array.from(new Set(allBlogList.map(post => post.tag).filter(Boolean)));

    const filteredBlogs = selectedTag ? allBlogList.filter(post => post.tag === selectedTag) : allBlogList;


    return (
        <>
            {/* <Helmet>
                <title>{seoTitle}</title>
                <meta name="description" content={seoDescription} />
                <meta name="keywords" content={seoKeywords} />
                <meta name="author" content="Sales Trackify Team" />
            </Helmet> */}

            {seo && (
                <Seo
                    pageName="blogs"
                    title={seoTitle}
                    description={seoDescription}
                    keywords={seoKeywords}
                    url="https://salestrackify.com/blogs"
                    image="/seo/trackify-preview.png"
                />
            )}
            <div className="header-7" style={{ background: `url(${hero}) no-repeat` }}>
                <Navbar1
                    hideSearch
                    fixedWidth
                    navClass="navbar-dark "
                    buttonClass="btn-white text-white btn-sm"
                />
                <Hero />
            </div>

            <section className="pt-6 pb-4 position-relative">
                {/* <Container> */}
                <div style={{ marginLeft: '5%', marginRight: '5%' }}>
                    <Row className="justify-content-lg-between ">
                        <Col lg={12}>
                            <div className="d-flex flex-wrap  align-items-center mb-5">
                                <h5 className="me-2 fw-medium">Tags:</h5>
                                {uniqueTags.length > 0 ? (
                                    uniqueTags.map((tag, index) => (
                                        <button
                                            key={index}
                                            className={`btn btn-sm ${selectedTag === tag ? 'btn-primary' : 'btn-white'} mb-1 me-1`}
                                            onClick={() => setSelectedTag(tag ?? null)}
                                        >
                                            {tag}
                                        </button>
                                    ))
                                ) : (
                                    <p>No blog posts available.</p>
                                )}

                                {selectedTag && (
                                    <button
                                        className="btn btn-sm btn-danger mb-1 me-1"
                                        onClick={() => setSelectedTag(null)}
                                    >
                                        Clear Filter
                                    </button>
                                )}
                            </div>
                        </Col>

                        <Col lg={12}>
                            <Row className="mt-6" data-aos="fade-up">
                                {filteredBlogs.length > 0 ? (
                                    filteredBlogs.map((post) => (
                                        <Col lg={4} key={post.id}>
                                            <BlogPost2 Post1={post} />
                                        </Col>
                                    ))
                                ) : (
                                    <p>No blog posts available for the selected tag.</p>
                                )}
                            </Row>
                        </Col>
                    </Row>
                </div >
                {/* </Container> */}
            </section >
            {/* footer */}
            < Footer1 />

            <BackToTop />
        </>
    );
};

export default Blog;
